import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'
import { Dialog } from 'shared/UI/Dialog'
import withOutsideClickHandler from 'shared/hocs/withOutsideClickHandler'

import './style.css.scss'

const ItemDialog = (props) => {

  const setOutsideClick = (dialogElement) => {
    props.provideContainer(dialogElement)
    props.provideOutsideClickHandler(props.onClose)
  }

  return (
    <div className={`item-dialog-container ${props.dialogConfig.dialogClass}`}>
      <span className="overlay"/>
      <CSSTransition
        classNames="dialog-transition"
        timeout={300}
        in={true}
        mountOnEnter
        unmountOnExit
        appear={true}>
          <Dialog
            provideDialog={setOutsideClick}
            onClose={props.onClose}
            showButtons={false}>
            { props.dialogConfig.renderFunction() }
          </Dialog>
      </CSSTransition>
    </div>
  )
}

ItemDialog.propTypes = {
  provideContainer: PropTypes.func,
  provideOutsideClickHandler: PropTypes.func,
  dialogConfig: PropTypes.object,
  onClose: PropTypes.func
}

export default withOutsideClickHandler(ItemDialog)